export default "__VITE_ASSET__01ac99ca__"